'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ErrorOutlined = require('./lib/icons/ErrorOutlined');
  
  
  var _default = _ErrorOutlined;
  exports.default = _default;
  module.exports = _default;